<template>
    <div class="main">
        <c-panel :title="modoEdicao ? 'EDITAR FÓRMULA DE CÁLCULO' : 'NOVA FÓRMULA DE CÁLCULO'" titleIcon="fas fa-edit">

            <div v-if="!carregado" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>

            <el-form v-else label-position="top" :model="dados" ref="dados" @submit.native.prevent="salvar">

                <el-alert type="info" :closable="false" class="u-mb-15"
                    title="A fórmula é declarativa: combinações e pesos, sem expressões livres. Os campos que o método escolhido não utiliza são ignorados pelo sistema."></el-alert>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="16">
                        <el-form-item label="Nome" prop="nome" :rules="[$requiredBlur]">
                            <el-input v-model="dados.nome" maxlength="191" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Situação">
                            <el-select v-model="dados.situacao" style="width: 100%;">
                                <el-option :value="true" label="ATIVO"></el-option>
                                <el-option :value="false" label="INATIVO"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item label="Descrição">
                            <el-input type="textarea" :rows="2" v-model="dados.descricao"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <h4 class="u-mt-10">Cálculo</h4>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Média do período">
                            <el-select v-model="dados.metodo_periodo" style="width: 100%;">
                                <el-option v-for="m in enums.metodos_periodo" :key="m" :value="m" :label="rotulo(m)"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Média anual">
                            <el-select v-model="dados.metodo_anual" style="width: 100%;">
                                <el-option v-for="m in enums.metodos_anual" :key="m" :value="m" :label="rotulo(m)"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="4">
                        <el-form-item label="Casas decimais">
                            <el-select v-model="dados.casas_decimais" style="width: 100%;">
                                <el-option v-for="c in [0,1,2,3,4,5,6]" :key="c" :value="c" :label="String(c)"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="4">
                        <el-form-item label="Arredondamento">
                            <el-select v-model="dados.arredondamento" style="width: 100%;">
                                <el-option v-for="a in enums.arredondamentos" :key="a" :value="a" :label="rotulo(a)"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- Pesos: só quando a média anual é ponderada -->
                <template v-if="dados.metodo_anual === 'media_ponderada'">
                    <el-row :gutter="10">
                        <el-col :xs="24">
                            <el-form-item label="Pesos por período">
                                <el-row :gutter="10">
                                    <el-col :xs="12" :sm="3" v-for="p in pesos" :key="p.periodo">
                                        <el-input v-model="p.valor" v-mask="'##,##'">
                                            <template slot="prepend">{{ p.periodo }}º</template>
                                        </el-input>
                                    </el-col>
                                    <el-col :xs="12" :sm="4">
                                        <el-button icon="el-icon-plus" @click="addPeso" plain>PERÍODO</el-button>
                                        <el-button class="u-ml-10" icon="el-icon-minus" @click="removePeso" plain v-if="pesos.length > 1"></el-button>
                                    </el-col>
                                </el-row>
                                <small style="color: #909399;">Os pesos não precisam somar 1 nem 100 — o sistema divide pela soma deles.</small>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </template>

                <h4 class="u-mt-10">Recuperação e exame</h4>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Recuperação do período">
                            <el-select v-model="dados.tratamento_recuperacao" style="width: 100%;">
                                <el-option v-for="t in enums.tratamentos_recuperacao" :key="t" :value="t" :label="rotulo(t)"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="4" v-if="dados.tratamento_recuperacao === 'media_com_original'">
                        <el-form-item label="Peso da recuperação">
                            <el-input v-model="dados.peso_recuperacao" v-mask="'##,##'"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Exame final">
                            <el-select v-model="dados.tratamento_exame_final" style="width: 100%;">
                                <el-option v-for="t in enums.tratamentos_exame" :key="t" :value="t" :label="rotulo(t)"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="4" v-if="dados.tratamento_exame_final === 'media_com_anual'">
                        <el-form-item label="Peso do exame">
                            <el-input v-model="dados.peso_exame_final" v-mask="'##,##'"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <h4 class="u-mt-10">Aprovação</h4>
                <el-row :gutter="10">
                    <el-col :xs="12" :sm="6">
                        <el-form-item label="Média de aprovação">
                            <el-input v-model="dados.media_aprovacao" v-mask="'###,##'"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="6" v-if="dados.tratamento_exame_final !== 'nao_usa'">
                        <el-form-item label="Média pós-exame">
                            <el-input v-model="dados.media_aprovacao_pos_exame" v-mask="'###,##'"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="6">
                        <el-form-item label="Frequência mínima (%)">
                            <el-input v-model="dados.frequencia_minima" v-mask="'###,##'"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row class="u-mt-15">
                    <el-col :xs="24" class="u-text-right">
                        <router-link to="/admin/formula-calculo">
                            <el-button>VOLTAR</el-button>
                        </router-link>
                        <el-button class="u-ml-10" type="warning" @click="simular" plain>SIMULAR</el-button>
                        <el-button class="u-ml-10" type="primary" native-type="submit">SALVAR</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </c-panel>
    </div>
</template>

<script>
export default {
    data: () => ({
        dados: {
            nome: '', descricao: '', metodo_periodo: 'soma', metodo_anual: 'media_aritmetica',
            pesos_periodos: null, tratamento_recuperacao: 'substitui_se_maior', peso_recuperacao: '',
            tratamento_exame_final: 'substitui', peso_exame_final: '', media_aprovacao: '',
            media_aprovacao_pos_exame: '', frequencia_minima: '', casas_decimais: 2,
            arredondamento: 'baixo', situacao: true
        },
        pesos: [{ periodo: 1, valor: '1' }, { periodo: 2, valor: '1' }, { periodo: 3, valor: '1' }],
        enums: { metodos_periodo: [], metodos_anual: [], tratamentos_recuperacao: [], tratamentos_exame: [], arredondamentos: [] },
        modoEdicao: false,
        carregado: false
    }),
    mounted () { this.initForm() },
    methods: {
        rotulo (v) {
            const r = {
                soma: 'Soma das avaliações', media_aritmetica: 'Média aritmética', media_ponderada: 'Média ponderada',
                maior_nota: 'Maior nota', ultimo_periodo: 'Último período',
                substitui_se_maior: 'Substitui quando for maior', media_com_original: 'Média com a nota original',
                ignora: 'Ignora a recuperação',
                substitui: 'Substitui a média (comportamento atual do sistema)',
                media_com_anual: 'Média com a nota anual', nao_usa: 'Não utiliza exame',
                nenhum: 'Nenhum', baixo: 'Truncar (comportamento atual do sistema)',
                cima: 'Sempre para cima', meio_acima: 'Meio para cima', meio_abaixo: 'Meio para baixo'
            }
            return r[v] || v
        },
        addPeso () { this.pesos.push({ periodo: this.pesos.length + 1, valor: '1' }) },
        removePeso () { this.pesos.pop() },
        montarPayload () {
            const p = JSON.parse(JSON.stringify(this.dados))
            if (this.dados.metodo_anual === 'media_ponderada') {
                const mapa = {}
                this.pesos.forEach(x => { mapa[String(x.periodo)] = String(x.valor).replace(',', '.') })
                p.pesos_periodos = mapa
            } else {
                p.pesos_periodos = null
            }
            return p
        },
        initForm () {
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/formula-calculo/initForm`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                this.enums = {
                    metodos_periodo: r.data.metodos_periodo || [],
                    metodos_anual: r.data.metodos_anual || [],
                    tratamentos_recuperacao: r.data.tratamentos_recuperacao || [],
                    tratamentos_exame: r.data.tratamentos_exame || [],
                    arredondamentos: r.data.arredondamentos || []
                }
                // Sem edição, o formulário nasce com a configuração que reproduz o
                // comportamento atual do sistema — devolvida pela própria API.
                const legado = r.data.configuracao_legado || {}
                if (!this.$route.params.id) {
                    Object.keys(legado).forEach(k => {
                        if (this.dados[k] !== undefined && k !== 'nome') this.dados[k] = legado[k]
                    })
                    this.carregado = true
                } else {
                    this.modoEdicao = true
                    this.carregar(this.$route.params.id)
                }
            }).catch(e => this.$store.commit('throwException', e))
        },
        carregar (id) {
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/formula-calculo/getById/${id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                const reg = r.data || {}
                Object.keys(this.dados).forEach(k => {
                    if (reg[k] !== undefined && reg[k] !== null) this.dados[k] = reg[k]
                })
                this.dados.situacao = reg.situacao === false ? false : true
                if (reg.pesos_periodos && typeof reg.pesos_periodos === 'object') {
                    this.pesos = Object.keys(reg.pesos_periodos).map(k => ({ periodo: Number(k), valor: String(reg.pesos_periodos[k]) }))
                }
                this.carregado = true
            }).catch(e => this.$store.commit('throwException', e))
        },
        simular () {
            // Leva a configuração atual da tela para o simulador, sem salvar nada.
            this.$router.push({ path: '/admin/formula-calculo/simulador', query: { avulsa: JSON.stringify(this.montarPayload()) } })
        },
        salvar () {
            this.$refs.dados.validate(valid => {
                if (!valid) {
                    window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' })
                    return
                }
                window.eventBus.$emit('loading', true)
                const url = this.modoEdicao
                    ? `${this.$store.state.config.baseUrlApi}/api/formula-calculo/update/${this.$route.params.id}`
                    : `${this.$store.state.config.baseUrlApi}/api/formula-calculo/store`
                this.$axios.post(url, this.montarPayload(), this.$store.getters.getHeaderAuth).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Salvo com sucesso.', type: 'success' })
                    this.$router.push('/admin/formula-calculo')
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        }
    }
}
</script>
